import { render, staticRenderFns } from "./cardTwo.vue?vue&type=template&id=70e2d729&scoped=true&"
import script from "./cardTwo.vue?vue&type=script&lang=js&"
export * from "./cardTwo.vue?vue&type=script&lang=js&"
import style0 from "./cardTwo.vue?vue&type=style&index=0&id=70e2d729&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e2d729",
  null
  
)

export default component.exports